document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-famli-gift-close]');
  const disclosure = button && button.closest('.famli-product-gift');
  if (!disclosure) return;
  disclosure.open = false;
  disclosure.querySelector('summary').focus({ preventScroll: true });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const disclosure = event.target.closest('.famli-product-gift[open]');
  if (!disclosure) return;
  disclosure.open = false;
  disclosure.querySelector('summary').focus({ preventScroll: true });
});
